/**
 * Composed document.title — one writer, two inputs (XTRA-02 / NAV-11).
 *
 * PageShell owns the base ("Alarms · smart-e"); the alarm signal hook owns
 * the badge prefix ("(2🔴) "). Composing here means neither effect can
 * clobber the other regardless of effect ordering. In TB-embedded mode the
 * host page's title wins anyway — harmless.
 */
let base = "smart-e · Operator Console";
let alarmBadge = 0;

function write() {
  document.title = `${alarmBadge > 0 ? `(${alarmBadge}\u{1F534}) ` : ""}${base}`;
}

/** Set by PageShell on every route ("<page title> · smart-e"). */
export function setBaseTitle(t: string) {
  base = t;
  write();
}

/** Set by the alarm signal hook: count of active critical+major alarms. */
export function setAlarmBadge(count: number) {
  if (count === alarmBadge) return;
  alarmBadge = count;
  write();
}
